import script from "./ScreenView.vue?vue&type=script&setup=true&lang=js"
export * from "./ScreenView.vue?vue&type=script&setup=true&lang=js"

import "./ScreenView.vue?vue&type=style&index=0&id=17841531&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17841531"]])

export default __exports__